import React from 'react';

import { colorsPalette } from '../../theme';

const TestIcon = (props) => {
  const color = props?.color;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 40" fill="none" {...props}>
      <path
        fill={color ? color : colorsPalette.white}
        d="M39.3369 0.234375H0.670875C0.29992 0.234375 0 0.524624 0 0.883616V38.6847C0 39.0437 0.29992 39.334 0.670875 39.334H39.3369C39.7079 39.334 40.0078 39.0437 40.0078 38.6847V0.883616C40.0078 0.524624 39.7079 0.234375 39.3369 0.234375ZM38.6661 38.0355H1.34964V1.5405H38.6661V38.0355ZM11.4522 25.6541H6.06155C5.6906 25.6541 5.39068 25.9443 5.39068 26.3033V31.5202C5.39068 31.8792 5.6906 32.1694 6.06155 32.1694H11.4522C11.8232 32.1694 12.1231 31.8792 12.1231 31.5202V26.3033C12.1231 25.9443 11.8232 25.6541 11.4522 25.6541ZM10.7735 30.8709H6.73243V26.9602H10.7735V30.8709ZM12.3599 8.20859L8.08207 11.7527L6.49565 10.4389L5.61956 11.4319L7.64008 13.1046C7.76636 13.2116 7.92422 13.265 8.07418 13.265C8.23203 13.265 8.38988 13.2116 8.50827 13.1046L13.2202 9.19391L12.3599 8.20859ZM11.9258 17.6417L10.9708 16.7175L8.75294 18.8638L6.53511 16.7175L5.5801 17.6417L7.80583 19.788L5.58799 21.9343L6.543 22.8585L8.76084 20.7122L10.9787 22.8585L11.9337 21.9343L9.70795 19.788L11.9258 17.6417ZM15.4933 10.0112H34.625V11.3173H15.4933V10.0112ZM15.4933 19.1388H34.625V20.4449H15.4933V19.1388ZM15.4933 28.2587H34.625V29.5648H15.4933V28.2587Z"
      />
    </svg>
  );
};

export default TestIcon;
